import type { ILocationRepository, LocationSearchResult } from '../repositories/ILocationRepository.js';

interface Deps { locationRepository: ILocationRepository; }

export function createListLocationsByCodesUseCase({ locationRepository }: Deps) {
  return async function listLocationsByCodes(codes: string[]): Promise<LocationSearchResult[]> {
    return locationRepository.listByCodes(codes);
  };
}
